import React, { useState, useEffect } from 'react';
import { FaPen, FaArchive, FaSort } from "react-icons/fa";
import { collection, getDocs, deleteDoc, doc, getDoc } from "firebase/firestore";
import { db, storage } from '../firebaseConfig';
import { deleteObject, ref } from 'firebase/storage';
import { useNavigate } from 'react-router-dom';
import { CSVLink } from "react-csv";
import { Spinner } from 'react-bootstrap';
import './admin.css';

const AlbumsList = () => {
    const [events, setEvents] = useState([]);
    const [sortOrder, setSortOrder] = useState("asc");
    const [sortOrderTitle, setSortOrderTitle] = useState("desc");
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchEvents();
    }, []);

    const fetchEvents = async () => {
        const querySnapshot = await getDocs(collection(db, "albums"));
        const eventList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        const sortedEventList = eventList.sort((a, b) => {
            const nameA = a.title || '';
            const nameB = b.title || '';
            return nameA.localeCompare(nameB);
        });
        setEvents(sortedEventList);
        setIsLoading(false)
    };
    const handleSort = () => {
        const sortedEvents = [...events].sort((a, b) => {
            const dateA = new Date(a.date);
            const dateB = new Date(b.date);
            return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
        });
        setEvents(sortedEvents);
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    };

    const handleSortTitle = () => {
        const sortedEvents = [...events].sort((a, b) => {
            const nameA = a.title?.toLowerCase() || '';
            const nameB = b.title?.toLowerCase() || '';
            return sortOrderTitle === "asc" ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
        });
        setEvents(sortedEvents);
        setSortOrderTitle(sortOrderTitle === "asc" ? "desc" : "asc");
    };

    const deleteEvent = async (id) => {
        try {
            const eventDocRef = doc(db, "albums", id);

            const eventDocSnapshot = await getDoc(eventDocRef);
            const eventData = eventDocSnapshot.data();

            if (eventData && eventData.images) {
                const imageUrls = eventData.images.map(e => e.url);
                const imageNames = eventData.images.map(e => e.imageName);

                const deletePromises = imageUrls.map(async (url, index) => {
                    const storageRef = ref(storage, `albums/${id}/images/${imageNames[index]}`);
                    await deleteObject(storageRef);
                });
                await Promise.all(deletePromises);
            }
            if (eventData && eventData.videos) {
                const videoUrls = eventData.videos.map(e => e.url);
                const videoNames = eventData.videos.map(e => e.videoName);

                const deletePromises = videoUrls.map(async (url, index) => {
                    const storageRef = ref(storage, `albums/${id}/videos/${videoNames[index]}`);
                    await deleteObject(storageRef);
                });
                await Promise.all(deletePromises);;
            }

            await deleteDoc(eventDocRef);

            fetchEvents();
        } catch (error) {
            console.error('Error deleting album and its files:', error);
        }
    };

    const handleEdit = (event) => {
        navigate(`/albums/edit/${event.id}`);
    };

    const headers = [
        // { label: '#', key: 'i' },
        { label: 'Event Title', key: 'title' },
        { label: 'Description', key: 'desc' },
        { label: 'Category', key: 'cat' },
        { label: 'Date', key: 'date' },
        { label: 'Address', key: 'address' },
        { label: 'Latitude', key: 'lat' },
        { label: 'Longitude', key: 'lng' },
        { label: 'Images', key: 'images' },
        { label: 'Videos', key: 'videos' },
    ];

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric'
        });
    };
    const formatEventsForCSV = (events) => {
        return events.map((event, i) => ({
            // i:i+1,
            ...event,
            date: formatDate(event.date),
            images: event.images.map(image => image.name).join(', '),
            videos: event.videos.map(video => video.name).join(', ')
        }));
    }
    const csvData = formatEventsForCSV(events);

    return (

        <div className='my-5'>
            <h2 className="text-center">Albums</h2>

            <div className="d-flex justify-content-end mb-3">
                <CSVLink className='btn bg-lightgreen me-2' headers={headers} data={csvData} >
                    Export Albums
                </CSVLink>
                <button className="btn bg-lightgreen" onClick={() => { navigate('/albums/add') }}>Add New</button>
            </div>

            {isLoading ? (<div className="loading-container"
                style={{
                    position: "absolute", top: 0, left: 0,
                    zIndex: "100",
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                <Spinner style={{ width: '5rem', height: '5rem' }} />
            </div>) : (
                <div className="table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Title <FaSort className='ms-1' onClick={handleSortTitle} style={{ cursor: "pointer" }} /></th>
                                <th scope="col">Category</th>
                                <th scope="col">Description</th>
                                <th scope="col">Location</th>
                                <th scope="col">Date <FaSort className='ms-1' onClick={handleSort} style={{ cursor: "pointer" }} /></th>
                                <th scope="col">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {events.map((event, index) => (
                                <tr key={event.id}>
                                    <th scope="row">{index + 1}</th>
                                    <td>{event.title}</td>
                                    <td>{event.cat}</td>
                                    <td>{event.desc}</td>
                                    <td>{event.address}:{event.lat},{event.lng}</td>
                                    <td>{new Date(event.date).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric', })}</td>
                                    <td >
                                        <div className="d-flex justify-content-start">
                                            <button className="btn btn-sm me-2 bg-lightgreen" onClick={() => handleEdit(event)}><FaPen /></button>
                                            <button className="btn btn-sm bg-lightgreen" onClick={() => deleteEvent(event.id)}><FaArchive /></button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}


        </div>
    );
};

export default AlbumsList;
